import { Line } from 'react-chartjs-2';
import { Chart as ChartJS } from 'chart.js/auto';

export const DailyEarningsChart = ({ data }) => {
  // Define all days of the week in order
  const allDaysOfWeek = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
  ];

  // Trim whitespace from the `day` values in the API response
  const cleanedData = data.map(item => ({
    day: item.day.trim(), // Trim whitespace
    totalEarnings: item.totalEarnings
  }));

  // Create a map of earnings data for quick lookup
  const earningsMap = new Map(cleanedData.map(item => [item.day, item.totalEarnings]));

  // Prepare chart data
  const chartData = {
    labels: allDaysOfWeek, // Use days of the week as labels
    datasets: [{
      label: 'Daily Earnings',
      data: allDaysOfWeek.map(day => earningsMap.get(day) || 0), // Fill missing days with 0
      borderColor: '#4CAF50', // Green color for the line
      backgroundColor: 'rgba(76, 175, 80, 0.2)', // Light green fill
      fill: true, // Fill the area under the line
      tension: 0.4 // Smooth line
    }]
  };

  // Chart options
  const options = {
    plugins: {
      legend: {
        display: true,
        position: 'bottom'
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            const label = context.dataset.label || '';
            const value = context.raw || 0;
            return `${label}: $${value.toFixed(2)}`;
          }
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: (value) => `$${value}`
        }
      }
    }
  };

  return <Line data={chartData} options={options} />;
};